import { Box, styled } from "@mui/material";
import { colors } from '../../../theme/colors';

export const MainWrapper = styled(Box)({
  padding: "24px",
  background: "linear-gradient(135deg, #fef6f6 0%, #f8f9fb 100%)",
  minHeight: "100%",

  "& .page-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "24px",
    flexWrap: "wrap",
    gap: "16px",
  },
  "& .page-title": {
    fontSize: "28px",
    fontWeight: 700,
    color: colors.primary,
    lineHeight: 1.2,
    marginBottom: "6px",
  },
  "& .page-subtitle": {
    fontSize: "14px",
    color: "#637381",
    lineHeight: 1.5,
  },
  "& .create-btn": {
    minWidth: "170px",
    height: "48px",
    borderRadius: "12px",
    backgroundColor: colors.primary,
    textTransform: "none",
    color: "#fff",
    fontWeight: 600,
    fontSize: "15px",
    boxShadow: "0 8px 18px rgba(127, 29, 29, 0.18)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: "0 10px 22px rgba(127, 29, 29, 0.22)",
    },
  },
  "& .filters-card": {
    background: "#ffffff",
    border: "1px solid #dde7f0",
    borderRadius: "16px",
    padding: "20px 24px",
    boxShadow: "0 4px 12px rgba(127, 29, 29, 0.06)",
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "center",
    marginBottom: "24px",
  },
  "& .search-field": {
    flex: 1,
    minWidth: "280px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#fff",
      "& fieldset": {
        borderColor: "#d6e0ea",
      },
      "&:hover fieldset": {
        borderColor: colors.primary,
      },
      "&.Mui-focused fieldset": {
        borderColor: colors.primary,
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#637381",
      "&.Mui-focused": {
        color: colors.primary,
      },
    },
  },
  "& .filter-btn": {
    textTransform: "none",
    borderColor: "#d6e0ea",
    color: colors.primary,
    borderRadius: "12px",
    padding: "10px 20px",
    fontWeight: 500,
    fontSize: "14px",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: colors.primary,
      backgroundColor: "rgba(127, 29, 29, 0.04)",
    },
  },

  "& .table-container": {
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    backgroundColor: "#fff",
    border: "1px solid #dde7f0",
    marginBottom: "20px",
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "lightgray",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.primary,
      borderRadius: "10px",
      border: "2px solid lightgray",
    },
  },
  "& .MuiTableCell-head": {
    color: "#fff !important",
    fontSize: "13px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
  },
  "& .MuiTableCell-body": {
    fontSize: "14px",
    color: "#374151",
    borderBottom: "1px solid #f0f0f0",
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s ease",
  },
  "& .MuiTableRow-root:hover": {
    backgroundColor: colors.primaryLight,
  },
  "& .job-id-cell": {
    fontWeight: 600,
    color: colors.primary,
  },
  "& .role-text": {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a1a",
  },
  "& .role-subtext": {
    fontSize: "12px",
    color: "#919EAB",
  },
  "& .assign-btn": {
    color: colors.primary,
    "&:hover": {
      backgroundColor: "rgba(127, 29, 29, 0.08)",
    },
  },

  "& .pagination-container": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
  },
  "& .pagination-info": {
    fontSize: "13px",
    color: "#637381",
  },
  "& .pagination-buttons": {
    display: "flex",
    gap: "8px",
  },
  "& .btn": {
    backgroundColor: colors.primary,
    color: "#fff",
    textTransform: "none",
    borderRadius: "8px",
    fontWeight: 500,
    fontSize: "13px",
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: colors.primaryHover,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.buttonDisabled.background,
      color: colors.buttonDisabled.color,
      opacity: 1,
      cursor: "not-allowed",
    },
  },

  "@media (max-width: 900px)": {
    padding: "16px",

    "& .page-header": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& .create-btn": {
      width: "100%",
    },
    "& .pagination-container": {
      flexDirection: "column",
      gap: "12px",
      alignItems: "stretch",
    },
  },
});
